<script setup lang="ts">
import { computed } from 'vue'
import type LeadingParty from '@/modules/election/models/leading_party.model'

interface Props {
  candidate: LeadingParty
}

const props = defineProps<Props>()

const cardStyle = computed(() => ({
  borderLeft: `5px solid ${props.candidate.color}`,
  backgroundColor: '#fff',
  padding: '8px 12px',
  marginBottom: '8px',
  borderRadius: '4px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}))
</script>

<template>
  <div class="minor-candidate-card" :style="cardStyle">
    <div class="info">
      <div class="name font-bold">{{ candidate.name }}</div>
      <div class="stats text-sm text-gray-600">
        {{ candidate.votes.toLocaleString() }} votes
      </div>
    </div>
    <div class="percentage font-bold text-lg" :style="{ color: candidate.color }">
      {{ candidate.percentage }}%
    </div>
  </div>
</template>

<style scoped>
.minor-candidate-card {
    transition: transform 0.2s;
}
.minor-candidate-card:hover {
    transform: translateX(2px);
}
</style>
